import { FC } from 'react'

type Props = {
  text: string
}

const StepConfirmTitle: FC<Props> = ({ text }) => {
  return <span>{text}</span>
}

export { StepConfirmTitle }
